import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Colors, Icon } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';

type Props = {
  children: ReactNode;
  isVisible: boolean;
  setIsVisible: (param: boolean) => void;
};

export const FloatingPopup = ({ children, isVisible, setIsVisible }: Props) => {
  const iconSize = 23;

  return !isVisible ? null : (
    <Outer>
      <IconWrapper
        onClick={() => {
          setIsVisible(false);
        }}
      >
        <Icon color="grey700" name="formX" size={iconSize} />
      </IconWrapper>
      {children}
    </Outer>
  );
};

const Outer = styled.div`
  background-color: white;
  border-top: 3px solid ${Colors.grey200};
  display: grid;
  place-items: center;
  width: 100%;
  // These styles help the popup stick to the bottom of the mobile and tablet view
  padding: 20px 0 67px 0;
  bottom: 0;
  position: fixed;
  z-index: 10;
  ${mediaQueries.tablet} {
    bottom: 0;
    padding-bottom: 67px;
  }
  ${mediaQueries.desktop} {
    border: 1px solid ${Colors.grey200};
    border-radius: 10px;
    height: max-content;
    max-width: 290px;
    padding: 20px 20px 20px 16px;
    // These styles help the popup stick to the left side of the desktop view
    position: sticky;
    bottom: 25px;
    right: 76%;
    width: 100%;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 10%;
  right: 4%;
  ${mediaQueries.tablet} {
    top: 24%;
  }
  ${mediaQueries.desktop} {
    top: 15px;
  }
`;
